module.exports = __webpack_public_path__ + "static/media/205-Pflegemassnahmen_ID_4.cb81410d.mp3";